

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface HighRiskParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface HighRisk {
    id?: number;
    name: string;
    
  parameters?: HighRiskParameter[];
  links?: any;
}

export abstract class HighRiskData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<HighRisk[]>;
  abstract create(url: string,data: HighRisk): Observable<any>;
  abstract update(url: string,data: HighRisk): Observable<any>;
  abstract delete(url: string): Observable<any>;
}